// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  --settings-card-pad: 18px;
  --settings-inner-pad: 14px;
  color: #e8edff;
}

.settings-page * {
  box-sizing: border-box;
}

.settings-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 20px 24px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, rgba(86, 50, 132, 0.7), rgba(24, 28, 55, 0.85));
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
  position: relative;
  overflow: hidden;
}

.settings-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(123, 213, 245, 0.15), transparent 35%),
    radial-gradient(circle at 80% 0%, rgba(155, 123, 245, 0.22), transparent 40%);
  pointer-events: none;
}

.settings-hero > * {
  position: relative;
  z-index: 1;
}

.settings-eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 12px;
  color: #8bc5ff;
  margin-bottom: 4px;
}

.settings-title {
  margin: 0 0 6px;
  color: #f9fbff;
  font-size: 28px;
}

.settings-description {
  margin: 0;
  color: rgba(232, 237, 255, 0.78);
  max-width: 720px;
}

.settings-hero-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.settings-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #e6ecff;
  font-weight: 600;
  font-size: 13px;
}

.settings-chip.success {
  background: rgba(106, 223, 160, 0.14);
  border-color: rgba(106, 223, 160, 0.3);
  color: #c9ffe2;
}

.settings-chip.muted {
  background: rgba(255, 255, 255, 0.05);
}

.settings-hero-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 12px 14px;
}

.settings-hero-stat {
  text-align: right;
}

.settings-hero-label {
  color: rgba(232, 237, 255, 0.7);
  font-size: 12px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.settings-hero-value {
  color: #f5f8ff;
  font-size: 22px;
  font-weight: 700;
}

.settings-hero-value.accent {
  color: #9b7bf5;
}

.settings-hero-divider {
  width: 1px;
  align-self: stretch;
  background: rgba(255, 255, 255, 0.08);
}

.settings-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.settings-tab {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #e9ecf6;
  border-radius: 12px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.15s ease-in-out;
}

.settings-tab:hover {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.07);
}

.settings-tab.active {
  background: linear-gradient(135deg, #7b7df5, #4c7dd6);
  color: #0c1023;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  border-color: transparent;
}

.settings-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1.05fr);
  gap: 16px;
  align-items: start;
  margin-bottom: 16px;
}

.settings-main {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.settings-card {
  background: linear-gradient(145deg, rgba(32, 24, 54, 0.92), rgba(17, 20, 38, 0.9));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: var(--settings-card-pad);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45);
  position: relative;
  overflow: hidden;
}

.settings-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 25% 15%, rgba(123, 213, 245, 0.08), transparent 35%),
    radial-gradient(circle at 85% 0%, rgba(155, 123, 245, 0.14), transparent 40%);
  pointer-events: none;
}

.settings-card > * {
  position: relative;
  z-index: 1;
}

.settings-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.settings-card-title {
  font-size: 14px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f5f6fb;
}

.settings-card-subtitle {
  color: rgba(232, 237, 255, 0.72);
  font-size: 13px;
  margin-top: 4px;
  max-width: 720px;
}

.settings-edit-btn {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #e6ecff;
  border-radius: 10px;
  padding: 8px 12px;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.settings-edit-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.settings-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.account-field-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.account-field-grid .settings-field--wide {
  grid-column: span 2;
}

.settings-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(232, 237, 255, 0.6);
}

.settings-field {
  min-width: 0;
}

.settings-value {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  padding: 10px var(--settings-inner-pad);
  color: #f5f8ff;
  font-weight: 700;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.35;
}

.profile-meta {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.profile-avatar {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  display: grid;
  place-items: center;
}

.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-bio {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px;
  border-radius: 12px;
  color: #e4e8ff;
  font-size: 14px;
}

.settings-tag-block {
  margin-top: 10px;
}

.tag-label {
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(232, 237, 255, 0.6);
  margin-bottom: 6px;
}

.settings-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.settings-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
  border: 1px solid rgba(123, 213, 245, 0.25);
  background: rgba(123, 213, 245, 0.12);
  color: #d5ecff;
}

.settings-pill.soft {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.12);
  color: #eef2ff;
}

.settings-pill.accent {
  background: rgba(155, 123, 245, 0.15);
  border-color: rgba(155, 123, 245, 0.35);
  color: #e7dcff;
}

.settings-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-list {
  margin-top: 4px;
}

.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.status-row:last-child {
  border-bottom: none;
}

.status-label {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  color: #e6ecff;
  font-weight: 600;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot.good {
  background: #6adfa0;
  box-shadow: 0 0 0 4px rgba(106, 223, 160, 0.15);
}

.status-dot.warn {
  background: #f5c56b;
  box-shadow: 0 0 0 4px rgba(245, 197, 107, 0.16);
}

.status-value {
  font-weight: 700;
}

.status-value.good {
  color: #6adfa0;
}

.status-value.warn {
  color: #f5c56b;
}

.ghost-button {
  width: 100%;
  margin-top: 8px;
  padding: 10px var(--settings-inner-pad);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #eaf0ff;
  font-weight: 700;
  cursor: pointer;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}

.stat-row {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px var(--settings-inner-pad);
}

.stat-label {
  color: rgba(232, 237, 255, 0.7);
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stat-value {
  color: #f7f8ff;
  font-weight: 700;
  margin-top: 4px;
}

.action-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: stretch;
}

.action-button {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px var(--settings-card-pad);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #f5f8ff;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.04);
  transition: all 0.12s ease-in-out;
  font-weight: 700;
}

.action-button:hover {
  transform: translateY(-1px);
  border-color: rgba(255, 255, 255, 0.2);
}

.action-button.primary {
  background: linear-gradient(135deg, rgba(123, 213, 245, 0.2), rgba(75, 134, 247, 0.28));
}

.action-button.warning {
  background: linear-gradient(135deg, rgba(245, 197, 107, 0.16), rgba(247, 144, 75, 0.2));
}

.action-button.danger {
  background: linear-gradient(135deg, rgba(247, 144, 75, 0.16), rgba(247, 94, 94, 0.25));
}

.action-title {
  font-size: 14px;
  margin: 0;
}

.action-desc {
  font-size: 12px;
  color: rgba(232, 237, 255, 0.7);
  margin-top: 3px;
}

.action-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 6px;
}

.section-label {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 12px;
  color: rgba(232, 237, 255, 0.7);
  margin-bottom: 8px;
}

.activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.activity-list li {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px var(--settings-inner-pad);
  gap: 12px;
}

.activity-title {
  font-weight: 700;
  color: #f7f8ff;
}

.activity-meta {
  color: rgba(232, 237, 255, 0.68);
  font-size: 13px;
}

.activity-time {
  color: rgba(232, 237, 255, 0.65);
  font-size: 13px;
  white-space: nowrap;
}

.session-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.session-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 10px var(--settings-inner-pad);
  border-radius: 12px;
  gap: 12px;
}

.session-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.session-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
  display: grid;
  place-items: center;
  color: #dce6ff;
}

.session-title {
  font-weight: 700;
  color: #f7f8ff;
}

.session-location {
  color: rgba(232, 237, 255, 0.65);
  font-size: 13px;
}

.session-pill {
  border: none;
  border-radius: 999px;
  padding: 6px 12px;
  font-weight: 700;
  cursor: pointer;
  color: #0f1426;
}

.session-pill.good {
  background: #6adfa0;
}

.session-pill.danger {
  background: #f95f62;
  color: #fff;
}

.settings-highlight-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.settings-highlight {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 12px;
  color: #f5f8ff;
}

.settings-highlight-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(123, 213, 245, 0.14);
  display: grid;
  place-items: center;
  margin-bottom: 8px;
  color: #d1eaff;
}

.settings-highlight-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.settings-highlight-text {
  color: rgba(232, 237, 255, 0.72);
  font-size: 13px;
}

/* === Subscription === */
.subscription-layout {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.subscription-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--settings-card-pad);
}

.subscription-current {
  display: grid;
  grid-template-columns: minmax(0, 3fr) 1fr;
  gap: 16px;
  align-items: center;
}

.subscription-current-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sub-plan-heading {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.sub-plan-title {
  font-size: 18px;
  font-weight: 700;
  color: #f7f8ff;
}

.sub-plan-subtitle {
  color: rgba(232, 237, 255, 0.7);
  margin-top: 4px;
}

.sub-plan-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.sub-plan-value {
  color: #f7f8ff;
  font-weight: 700;
}

.sub-plan-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.primary-btn {
  border: none;
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 800;
  cursor: pointer;
  color: #0f1426;
  background: linear-gradient(135deg, #7b7df5, #4c7dd6);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.primary-btn.subtle {
  background: rgba(255, 255, 255, 0.1);
  color: #f7f8ff;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.ghost-button.subtle {
  background: rgba(255, 255, 255, 0.08);
}

.ghost-button.compact {
  width: auto;
  margin-top: 0;
  padding: 8px 12px;
}

.sub-plan-actions .ghost-button,
.danger-row .ghost-button,
.help-actions .ghost-button {
  width: auto;
  margin-top: 0;
}

.subscription-price {
  text-align: right;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.price-amount {
  font-size: 32px;
  font-weight: 800;
  color: #f7f8ff;
}

.price-cadence {
  color: rgba(232, 237, 255, 0.7);
}

.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.plan-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.plan-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.plan-name {
  font-weight: 700;
  color: #f7f8ff;
}

.plan-price {
  font-size: 20px;
  font-weight: 800;
  margin-top: 4px;
  color: #f7f8ff;
}

.plan-cadence {
  color: rgba(232, 237, 255, 0.72);
}

.plan-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: rgba(232, 237, 255, 0.8);
  font-size: 14px;
}

.addon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.addon-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.addon-name {
  font-weight: 700;
  color: #f7f8ff;
}

.addon-price {
  color: #e7dcff;
  font-weight: 700;
  margin-top: 4px;
}

.addon-desc {
  color: rgba(232, 237, 255, 0.7);
  font-size: 13px;
  margin-top: 4px;
}

.addon-toggle {
  width: 44px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.08);
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.addon-toggle.on {
  background: linear-gradient(135deg, #7b7df5, #4c7dd6);
  border-color: transparent;
  justify-content: flex-end;
}

.addon-toggle.off {
  justify-content: flex-start;
}

.toggle-knob {
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.subscription-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.billing-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.billing-section {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 10px;
}

.billing-copy {
  color: #f7f8ff;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.billing-copy.success {
  color: #6adfa0;
  font-weight: 700;
}

.billing-copy.subtle {
  color: rgba(232, 237, 255, 0.65);
  font-size: 13px;
}

.link-button {
  background: none;
  border: none;
  color: #8bc5ff;
  padding: 0;
  margin-top: 6px;
  font-weight: 700;
  cursor: pointer;
}

.invoices-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.invoice-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.invoice-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px var(--settings-card-pad);
}

.invoice-date {
  color: #f7f8ff;
  font-weight: 700;
}

.invoice-label {
  color: rgba(232, 237, 255, 0.7);
  font-size: 13px;
}

.invoice-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.invoice-amount {
  color: #f7f8ff;
  font-weight: 800;
}

.settings-chip.small {
  padding: 6px 10px;
  font-size: 12px;
}

.danger-card {
  border-color: rgba(249, 95, 98, 0.25);
}

.danger-text {
  color: #f95f62;
}

.danger-row {
  margin-top: 10px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.danger-title {
  color: #f7f8ff;
  font-weight: 700;
}

.danger-btn {
  border: none;
  border-radius: 12px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f95f62;
  color: #fff;
  cursor: pointer;
  font-weight: 800;
}

.help-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.help-actions {
  display: flex;
  gap: 10px;
}

/* === Defaults === */
.defaults-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.defaults-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.defaults-actions {
  display: flex;
  gap: 10px;
}

.defaults-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-heading {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  color: #f7f8ff;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.defaults-grid {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.settings-value.with-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.settings-value-button {
  width: 100%;
  cursor: pointer;
  color: inherit;
}

.settings-value-button-inline {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: transparent;
  border: 0;
  color: inherit;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.settings-value.with-action {
  padding-right: 8px;
}

.field-helper {
  color: rgba(232, 237, 255, 0.65);
  font-size: 12px;
  margin-top: 4px;
}

.toggle-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.toggle-label {
  color: #f7f8ff;
  font-weight: 700;
}

.favorites-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 12px;
  border-radius: 12px;
}

.favorites-label {
  font-weight: 700;
  color: #f7f8ff;
}

.favorites-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.favorites-count {
  justify-self: end;
  color: rgba(232, 237, 255, 0.75);
  font-weight: 700;
}

.selector-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
}

.selector-title {
  color: #f7f8ff;
  font-weight: 700;
  margin-bottom: 8px;
}

.selector-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.selector-pill {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #e6ecff;
  border-radius: 10px;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
  font-weight: 700;
}

.selector-pill.selected {
  background: rgba(106, 223, 160, 0.12);
  border-color: rgba(106, 223, 160, 0.45);
  color: #c9ffe2;
}

.language-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 8px 0 12px;
}

.language-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.language-options .selector-pill {
  min-width: 120px;
  text-align: center;
}

.settings-value.language-value {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.addon-toggle.small {
  width: 42px;
  height: 22px;
}

.reset-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.reset-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.primary-btn.compact,
.ghost-button.compact,
.danger-btn.compact {
  padding: 8px 12px;
}

/* === API === */
.api-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.api-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.api-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.api-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.api-toggle-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.api-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.api-key-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.api-key-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.api-key-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.api-key-title {
  font-weight: 800;
  color: #f7f8ff;
}

.api-key-meta {
  color: rgba(232, 237, 255, 0.72);
  font-size: 13px;
}

.api-key-value {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 10px;
  color: #d3e3ff;
  font-family: "SFMono-Regular", Consolas, Menlo, monospace;
  letter-spacing: 0.04em;
}

.api-key-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.api-key-last {
  color: rgba(232, 237, 255, 0.7);
}

.api-key-actions {
  display: flex;
  gap: 8px;
}

.quota-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

.quota-block {
  padding: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.quota-label {
  color: rgba(232, 237, 255, 0.7);
  font-weight: 600;
}

.quota-value {
  color: #f7f8ff;
  font-weight: 800;
  font-size: 22px;
}

.quota-helper {
  color: rgba(232, 237, 255, 0.65);
}

.bar-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bar-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bar-label {
  display: flex;
  justify-content: space-between;
  color: #f7f8ff;
  font-weight: 700;
}

.bar-percent {
  color: rgba(232, 237, 255, 0.75);
  font-size: 13px;
}

.bar-track {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 999px;
}

.bar-helper {
  color: rgba(232, 237, 255, 0.7);
  font-size: 13px;
}

.warning-banner {
  margin-top: 6px;
  padding: 12px;
  border-radius: 12px;
  background: rgba(249, 95, 98, 0.08);
  border: 1px solid rgba(249, 95, 98, 0.2);
  display: flex;
  gap: 10px;
  align-items: center;
}

.warning-title {
  color: #f7f8ff;
  font-weight: 700;
}

.warning-text {
  color: rgba(232, 237, 255, 0.75);
}

.scope-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  margin-top: 8px;
}

.scope-pill {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  padding: 10px 12px;
  color: #e6ecff;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.scope-pill input {
  pointer-events: none;
}

.scope-pill.selected {
  border-color: rgba(106, 223, 160, 0.4);
  background: rgba(106, 223, 160, 0.12);
  color: #c9ffe2;
}

.resource-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

.resource-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.resource-title {
  color: #f7f8ff;
  font-weight: 800;
}

.resource-desc {
  color: rgba(232, 237, 255, 0.75);
  font-size: 13px;
}

.quickstart {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px;
}

.quickstart-title {
  color: #f7f8ff;
  font-weight: 800;
  margin-bottom: 6px;
}

.quickstart-code {
  margin: 0;
  white-space: pre-wrap;
  color: #b7ffd1;
  font-family: "SFMono-Regular", Consolas, Menlo, monospace;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.audit-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audit-head,
.audit-row {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 0.5fr;
  gap: 10px;
  align-items: center;
}

.audit-head {
  color: rgba(232, 237, 255, 0.75);
  font-weight: 700;
}

.audit-row {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px;
  color: #f7f8ff;
}

.status-pill {
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
  text-align: center;
}

.status-pill.ok {
  background: rgba(106, 223, 160, 0.15);
  color: #c9ffe2;
}

.status-pill.warn {
  background: rgba(249, 95, 98, 0.15);
  color: #ffc9c9;
}

/* === AI Assistant === */
.ai-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ai-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.slider-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: center;
}

.slider-track {
  position: relative;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.slider-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(135deg, #7b7df5, #4c7dd6);
}

.slider-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.slider-value {
  color: #f7f8ff;
  font-weight: 700;
}

.cta-banner {
  padding: 12px;
  border-radius: 12px;
  background: rgba(75, 134, 247, 0.15);
  border: 1px solid rgba(75, 134, 247, 0.35);
  color: #dce8ff;
  font-weight: 700;
}

.action-choice {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.action-choice-title {
  font-weight: 800;
  color: #f7f8ff;
}

.model-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.model-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.model-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.model-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #7bd5f5;
  box-shadow: 0 0 0 6px rgba(123, 213, 245, 0.16);
}

.model-label {
  color: #f7f8ff;
  font-weight: 800;
}

.model-desc {
  color: rgba(232, 237, 255, 0.78);
  font-size: 13px;
}

.export-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.export-buttons {
  display: flex;
  gap: 8px;
}

.ai-reset-row {
  padding: 0;
}

/* === Security === */
.security-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.security-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.security-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
}

.qr-box {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 12px;
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px;
}

.qr-placeholder {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 800;
}

.session-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.security-log .activity-list-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 8px 10px;
}

.password-rules {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rule-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f7f8ff;
}

.privacy-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.privacy-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.settings-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1200;
  max-width: 420px;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 28px rgba(3, 9, 30, 0.35);
  backdrop-filter: blur(8px);
}

.settings-toast.info {
  color: #eaf0ff;
  background: rgba(49, 82, 174, 0.92);
}

.settings-toast.success {
  color: #dfffea;
  background: rgba(23, 121, 70, 0.92);
}

.settings-toast.error {
  color: #ffe8ea;
  background: rgba(150, 33, 54, 0.92);
}

.settings-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(5, 8, 20, 0.58);
  display: grid;
  place-items: center;
  padding: 20px;
}

.settings-dialog {
  width: min(520px, 100%);
  border-radius: 14px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: linear-gradient(155deg, rgba(25, 33, 72, 0.96), rgba(16, 22, 50, 0.96));
  box-shadow: 0 24px 60px rgba(4, 8, 25, 0.42);
}

.settings-dialog.danger {
  border-color: rgba(231, 82, 119, 0.4);
}

.settings-dialog.warning {
  border-color: rgba(231, 174, 82, 0.4);
}

.settings-dialog-title {
  font-size: 18px;
  font-weight: 800;
  color: #f6f8ff;
}

.settings-dialog-message {
  color: rgba(232, 237, 255, 0.85);
  font-size: 14px;
}

.settings-dialog-password-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-dialog-input {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.18);
  color: #f7f8ff;
}

.settings-dialog-input::placeholder {
  color: rgba(232, 237, 255, 0.56);
}

.settings-dialog-error {
  color: #ff8ea3;
  font-size: 13px;
  font-weight: 700;
}

.settings-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 1100px) {
  .settings-hero {
    flex-direction: column;
  }

  .settings-hero-meta {
    width: 100%;
    justify-content: space-between;
  }

  .settings-row {
    grid-template-columns: 1fr;
  }

  .account-field-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .subscription-current {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .settings-tabs {
    gap: 8px;
  }

  .settings-tab {
    width: 100%;
    justify-content: flex-start;
  }

  .settings-hero-meta {
    flex-direction: column;
    align-items: flex-start;
  }

  .account-field-grid {
    grid-template-columns: 1fr;
  }

  .account-field-grid .settings-field--wide {
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Settings/settings.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mFAAmF;EACnF,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;iFAC+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;iFAC+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,yDAAyD;EACzD,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2CAA2C;EAC3C,mFAAmF;EACnF,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".settings-page {\n  --settings-card-pad: 18px;\n  --settings-inner-pad: 14px;\n  color: #e8edff;\n}\n\n.settings-page * {\n  box-sizing: border-box;\n}\n\n.settings-hero {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 18px;\n  padding: 20px 24px;\n  margin-bottom: 16px;\n  background: linear-gradient(135deg, rgba(86, 50, 132, 0.7), rgba(24, 28, 55, 0.85));\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n  position: relative;\n  overflow: hidden;\n}\n\n.settings-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20%, rgba(123, 213, 245, 0.15), transparent 35%),\n    radial-gradient(circle at 80% 0%, rgba(155, 123, 245, 0.22), transparent 40%);\n  pointer-events: none;\n}\n\n.settings-hero > * {\n  position: relative;\n  z-index: 1;\n}\n\n.settings-eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 12px;\n  color: #8bc5ff;\n  margin-bottom: 4px;\n}\n\n.settings-title {\n  margin: 0 0 6px;\n  color: #f9fbff;\n  font-size: 28px;\n}\n\n.settings-description {\n  margin: 0;\n  color: rgba(232, 237, 255, 0.78);\n  max-width: 720px;\n}\n\n.settings-hero-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.settings-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  color: #e6ecff;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.settings-chip.success {\n  background: rgba(106, 223, 160, 0.14);\n  border-color: rgba(106, 223, 160, 0.3);\n  color: #c9ffe2;\n}\n\n.settings-chip.muted {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.settings-hero-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 12px 14px;\n}\n\n.settings-hero-stat {\n  text-align: right;\n}\n\n.settings-hero-label {\n  color: rgba(232, 237, 255, 0.7);\n  font-size: 12px;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.settings-hero-value {\n  color: #f5f8ff;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.settings-hero-value.accent {\n  color: #9b7bf5;\n}\n\n.settings-hero-divider {\n  width: 1px;\n  align-self: stretch;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.settings-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.settings-tab {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  color: #e9ecf6;\n  border-radius: 12px;\n  padding: 10px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-weight: 700;\n  transition: all 0.15s ease-in-out;\n}\n\n.settings-tab:hover {\n  border-color: rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.settings-tab.active {\n  background: linear-gradient(135deg, #7b7df5, #4c7dd6);\n  color: #0c1023;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);\n  border-color: transparent;\n}\n\n.settings-row {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1.05fr);\n  gap: 16px;\n  align-items: start;\n  margin-bottom: 16px;\n}\n\n.settings-main {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.settings-card {\n  background: linear-gradient(145deg, rgba(32, 24, 54, 0.92), rgba(17, 20, 38, 0.9));\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 18px;\n  padding: var(--settings-card-pad);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45);\n  position: relative;\n  overflow: hidden;\n}\n\n.settings-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 25% 15%, rgba(123, 213, 245, 0.08), transparent 35%),\n    radial-gradient(circle at 85% 0%, rgba(155, 123, 245, 0.14), transparent 40%);\n  pointer-events: none;\n}\n\n.settings-card > * {\n  position: relative;\n  z-index: 1;\n}\n\n.settings-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.settings-card-title {\n  font-size: 14px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #f5f6fb;\n}\n\n.settings-card-subtitle {\n  color: rgba(232, 237, 255, 0.72);\n  font-size: 13px;\n  margin-top: 4px;\n  max-width: 720px;\n}\n\n.settings-edit-btn {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  color: #e6ecff;\n  border-radius: 10px;\n  padding: 8px 12px;\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.settings-edit-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.settings-field-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.account-field-grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.account-field-grid .settings-field--wide {\n  grid-column: span 2;\n}\n\n.settings-field label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(232, 237, 255, 0.6);\n}\n\n.settings-field {\n  min-width: 0;\n}\n\n.settings-value {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n  padding: 10px var(--settings-inner-pad);\n  color: #f5f8ff;\n  font-weight: 700;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  line-height: 1.35;\n}\n\n.profile-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.profile-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  display: grid;\n  place-items: center;\n}\n\n.profile-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profile-bio {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 12px;\n  border-radius: 12px;\n  color: #e4e8ff;\n  font-size: 14px;\n}\n\n.settings-tag-block {\n  margin-top: 10px;\n}\n\n.tag-label {\n  font-size: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(232, 237, 255, 0.6);\n  margin-bottom: 6px;\n}\n\n.settings-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.settings-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 13px;\n  border: 1px solid rgba(123, 213, 245, 0.25);\n  background: rgba(123, 213, 245, 0.12);\n  color: #d5ecff;\n}\n\n.settings-pill.soft {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #eef2ff;\n}\n\n.settings-pill.accent {\n  background: rgba(155, 123, 245, 0.15);\n  border-color: rgba(155, 123, 245, 0.35);\n  color: #e7dcff;\n}\n\n.settings-side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.status-list {\n  margin-top: 4px;\n}\n\n.status-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.status-row:last-child {\n  border-bottom: none;\n}\n\n.status-label {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  color: #e6ecff;\n  font-weight: 600;\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.status-dot.good {\n  background: #6adfa0;\n  box-shadow: 0 0 0 4px rgba(106, 223, 160, 0.15);\n}\n\n.status-dot.warn {\n  background: #f5c56b;\n  box-shadow: 0 0 0 4px rgba(245, 197, 107, 0.16);\n}\n\n.status-value {\n  font-weight: 700;\n}\n\n.status-value.good {\n  color: #6adfa0;\n}\n\n.status-value.warn {\n  color: #f5c56b;\n}\n\n.ghost-button {\n  width: 100%;\n  margin-top: 8px;\n  padding: 10px var(--settings-inner-pad);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #eaf0ff;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n}\n\n.stat-row {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px var(--settings-inner-pad);\n}\n\n.stat-label {\n  color: rgba(232, 237, 255, 0.7);\n  font-size: 12px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.stat-value {\n  color: #f7f8ff;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\n.action-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  align-items: stretch;\n}\n\n.action-button {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px var(--settings-card-pad);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: #f5f8ff;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.04);\n  transition: all 0.12s ease-in-out;\n  font-weight: 700;\n}\n\n.action-button:hover {\n  transform: translateY(-1px);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.action-button.primary {\n  background: linear-gradient(135deg, rgba(123, 213, 245, 0.2), rgba(75, 134, 247, 0.28));\n}\n\n.action-button.warning {\n  background: linear-gradient(135deg, rgba(245, 197, 107, 0.16), rgba(247, 144, 75, 0.2));\n}\n\n.action-button.danger {\n  background: linear-gradient(135deg, rgba(247, 144, 75, 0.16), rgba(247, 94, 94, 0.25));\n}\n\n.action-title {\n  font-size: 14px;\n  margin: 0;\n}\n\n.action-desc {\n  font-size: 12px;\n  color: rgba(232, 237, 255, 0.7);\n  margin-top: 3px;\n}\n\n.action-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.activity-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n  margin-top: 6px;\n}\n\n.section-label {\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-size: 12px;\n  color: rgba(232, 237, 255, 0.7);\n  margin-bottom: 8px;\n}\n\n.activity-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.activity-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px var(--settings-inner-pad);\n  gap: 12px;\n}\n\n.activity-title {\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.activity-meta {\n  color: rgba(232, 237, 255, 0.68);\n  font-size: 13px;\n}\n\n.activity-time {\n  color: rgba(232, 237, 255, 0.65);\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.session-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.session-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 10px var(--settings-inner-pad);\n  border-radius: 12px;\n  gap: 12px;\n}\n\n.session-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.session-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.07);\n  display: grid;\n  place-items: center;\n  color: #dce6ff;\n}\n\n.session-title {\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.session-location {\n  color: rgba(232, 237, 255, 0.65);\n  font-size: 13px;\n}\n\n.session-pill {\n  border: none;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-weight: 700;\n  cursor: pointer;\n  color: #0f1426;\n}\n\n.session-pill.good {\n  background: #6adfa0;\n}\n\n.session-pill.danger {\n  background: #f95f62;\n  color: #fff;\n}\n\n.settings-highlight-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.settings-highlight {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 12px;\n  color: #f5f8ff;\n}\n\n.settings-highlight-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: rgba(123, 213, 245, 0.14);\n  display: grid;\n  place-items: center;\n  margin-bottom: 8px;\n  color: #d1eaff;\n}\n\n.settings-highlight-title {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.settings-highlight-text {\n  color: rgba(232, 237, 255, 0.72);\n  font-size: 13px;\n}\n\n/* === Subscription === */\n.subscription-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.subscription-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--settings-card-pad);\n}\n\n.subscription-current {\n  display: grid;\n  grid-template-columns: minmax(0, 3fr) 1fr;\n  gap: 16px;\n  align-items: center;\n}\n\n.subscription-current-left {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sub-plan-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n}\n\n.sub-plan-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.sub-plan-subtitle {\n  color: rgba(232, 237, 255, 0.7);\n  margin-top: 4px;\n}\n\n.sub-plan-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n}\n\n.sub-plan-value {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.sub-plan-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.primary-btn {\n  border: none;\n  border-radius: 12px;\n  padding: 10px 16px;\n  font-weight: 800;\n  cursor: pointer;\n  color: #0f1426;\n  background: linear-gradient(135deg, #7b7df5, #4c7dd6);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n}\n\n.primary-btn.subtle {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f7f8ff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.ghost-button.subtle {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.ghost-button.compact {\n  width: auto;\n  margin-top: 0;\n  padding: 8px 12px;\n}\n\n.sub-plan-actions .ghost-button,\n.danger-row .ghost-button,\n.help-actions .ghost-button {\n  width: auto;\n  margin-top: 0;\n}\n\n.subscription-price {\n  text-align: right;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n}\n\n.price-amount {\n  font-size: 32px;\n  font-weight: 800;\n  color: #f7f8ff;\n}\n\n.price-cadence {\n  color: rgba(232, 237, 255, 0.7);\n}\n\n.plan-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.plan-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.plan-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.plan-name {\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.plan-price {\n  font-size: 20px;\n  font-weight: 800;\n  margin-top: 4px;\n  color: #f7f8ff;\n}\n\n.plan-cadence {\n  color: rgba(232, 237, 255, 0.72);\n}\n\n.plan-bullets {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: rgba(232, 237, 255, 0.8);\n  font-size: 14px;\n}\n\n.addon-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.addon-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 14px;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n}\n\n.addon-name {\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.addon-price {\n  color: #e7dcff;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\n.addon-desc {\n  color: rgba(232, 237, 255, 0.7);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.addon-toggle {\n  width: 44px;\n  height: 24px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.08);\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n}\n\n.addon-toggle.on {\n  background: linear-gradient(135deg, #7b7df5, #4c7dd6);\n  border-color: transparent;\n  justify-content: flex-end;\n}\n\n.addon-toggle.off {\n  justify-content: flex-start;\n}\n\n.toggle-knob {\n  width: 18px;\n  height: 18px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.subscription-columns {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 14px;\n}\n\n.billing-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.billing-section {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 10px;\n}\n\n.billing-copy {\n  color: #f7f8ff;\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.billing-copy.success {\n  color: #6adfa0;\n  font-weight: 700;\n}\n\n.billing-copy.subtle {\n  color: rgba(232, 237, 255, 0.65);\n  font-size: 13px;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: #8bc5ff;\n  padding: 0;\n  margin-top: 6px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.invoices-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.invoice-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.invoice-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px var(--settings-card-pad);\n}\n\n.invoice-date {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.invoice-label {\n  color: rgba(232, 237, 255, 0.7);\n  font-size: 13px;\n}\n\n.invoice-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.invoice-amount {\n  color: #f7f8ff;\n  font-weight: 800;\n}\n\n.settings-chip.small {\n  padding: 6px 10px;\n  font-size: 12px;\n}\n\n.danger-card {\n  border-color: rgba(249, 95, 98, 0.25);\n}\n\n.danger-text {\n  color: #f95f62;\n}\n\n.danger-row {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n}\n\n.danger-title {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.danger-btn {\n  border: none;\n  border-radius: 12px;\n  padding: 10px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #f95f62;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.help-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.help-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* === Defaults === */\n.defaults-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.defaults-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.defaults-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.defaults-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.section-heading {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  color: #f7f8ff;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n}\n\n.defaults-grid {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.settings-value.with-select {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.settings-value-button {\n  width: 100%;\n  cursor: pointer;\n  color: inherit;\n}\n\n.settings-value-button-inline {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: transparent;\n  border: 0;\n  color: inherit;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.settings-value.with-action {\n  padding-right: 8px;\n}\n\n.field-helper {\n  color: rgba(232, 237, 255, 0.65);\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.toggle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.toggle-label {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.favorites-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 12px;\n  border-radius: 12px;\n}\n\n.favorites-label {\n  font-weight: 700;\n  color: #f7f8ff;\n}\n\n.favorites-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.favorites-count {\n  justify-self: end;\n  color: rgba(232, 237, 255, 0.75);\n  font-weight: 700;\n}\n\n.selector-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.selector-title {\n  color: #f7f8ff;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.selector-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.selector-pill {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  color: #e6ecff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  text-align: left;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.selector-pill.selected {\n  background: rgba(106, 223, 160, 0.12);\n  border-color: rgba(106, 223, 160, 0.45);\n  color: #c9ffe2;\n}\n\n.language-selector {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 8px 0 12px;\n}\n\n.language-options {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.language-options .selector-pill {\n  min-width: 120px;\n  text-align: center;\n}\n\n.settings-value.language-value {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.addon-toggle.small {\n  width: 42px;\n  height: 22px;\n}\n\n.reset-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.reset-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.primary-btn.compact,\n.ghost-button.compact,\n.danger-btn.compact {\n  padding: 8px 12px;\n}\n\n/* === API === */\n.api-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.api-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.api-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.api-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.api-toggle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.api-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.api-key-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.api-key-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.api-key-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n}\n\n.api-key-title {\n  font-weight: 800;\n  color: #f7f8ff;\n}\n\n.api-key-meta {\n  color: rgba(232, 237, 255, 0.72);\n  font-size: 13px;\n}\n\n.api-key-value {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 10px;\n  color: #d3e3ff;\n  font-family: \"SFMono-Regular\", Consolas, Menlo, monospace;\n  letter-spacing: 0.04em;\n}\n\n.api-key-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.api-key-last {\n  color: rgba(232, 237, 255, 0.7);\n}\n\n.api-key-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.quota-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n}\n\n.quota-block {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.quota-label {\n  color: rgba(232, 237, 255, 0.7);\n  font-weight: 600;\n}\n\n.quota-value {\n  color: #f7f8ff;\n  font-weight: 800;\n  font-size: 22px;\n}\n\n.quota-helper {\n  color: rgba(232, 237, 255, 0.65);\n}\n\n.bar-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.bar-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.bar-label {\n  display: flex;\n  justify-content: space-between;\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.bar-percent {\n  color: rgba(232, 237, 255, 0.75);\n  font-size: 13px;\n}\n\n.bar-track {\n  width: 100%;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.05);\n  overflow: hidden;\n}\n\n.bar-fill {\n  height: 100%;\n  border-radius: 999px;\n}\n\n.bar-helper {\n  color: rgba(232, 237, 255, 0.7);\n  font-size: 13px;\n}\n\n.warning-banner {\n  margin-top: 6px;\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(249, 95, 98, 0.08);\n  border: 1px solid rgba(249, 95, 98, 0.2);\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.warning-title {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.warning-text {\n  color: rgba(232, 237, 255, 0.75);\n}\n\n.scope-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.scope-pill {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 12px;\n  padding: 10px 12px;\n  color: #e6ecff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.scope-pill input {\n  pointer-events: none;\n}\n\n.scope-pill.selected {\n  border-color: rgba(106, 223, 160, 0.4);\n  background: rgba(106, 223, 160, 0.12);\n  color: #c9ffe2;\n}\n\n.resource-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n}\n\n.resource-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.resource-title {\n  color: #f7f8ff;\n  font-weight: 800;\n}\n\n.resource-desc {\n  color: rgba(232, 237, 255, 0.75);\n  font-size: 13px;\n}\n\n.quickstart {\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.quickstart-title {\n  color: #f7f8ff;\n  font-weight: 800;\n  margin-bottom: 6px;\n}\n\n.quickstart-code {\n  margin: 0;\n  white-space: pre-wrap;\n  color: #b7ffd1;\n  font-family: \"SFMono-Regular\", Consolas, Menlo, monospace;\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  padding: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.audit-table {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.audit-head,\n.audit-row {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr 1fr 1fr 0.5fr;\n  gap: 10px;\n  align-items: center;\n}\n\n.audit-head {\n  color: rgba(232, 237, 255, 0.75);\n  font-weight: 700;\n}\n\n.audit-row {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px;\n  color: #f7f8ff;\n}\n\n.status-pill {\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.status-pill.ok {\n  background: rgba(106, 223, 160, 0.15);\n  color: #c9ffe2;\n}\n\n.status-pill.warn {\n  background: rgba(249, 95, 98, 0.15);\n  color: #ffc9c9;\n}\n\n/* === AI Assistant === */\n.ai-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ai-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.slider-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 12px;\n  align-items: center;\n}\n\n.slider-track {\n  position: relative;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.slider-fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #7b7df5, #4c7dd6);\n}\n\n.slider-thumb {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.slider-value {\n  color: #f7f8ff;\n  font-weight: 700;\n}\n\n.cta-banner {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(75, 134, 247, 0.15);\n  border: 1px solid rgba(75, 134, 247, 0.35);\n  color: #dce8ff;\n  font-weight: 700;\n}\n\n.action-choice {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.action-choice-title {\n  font-weight: 800;\n  color: #f7f8ff;\n}\n\n.model-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.model-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.model-card-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.model-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #7bd5f5;\n  box-shadow: 0 0 0 6px rgba(123, 213, 245, 0.16);\n}\n\n.model-label {\n  color: #f7f8ff;\n  font-weight: 800;\n}\n\n.model-desc {\n  color: rgba(232, 237, 255, 0.78);\n  font-size: 13px;\n}\n\n.export-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.export-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.ai-reset-row {\n  padding: 0;\n}\n\n/* === Security === */\n.security-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.security-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.security-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.data-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px;\n}\n\n.qr-box {\n  display: grid;\n  grid-template-columns: 80px 1fr;\n  gap: 12px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px;\n}\n\n.qr-placeholder {\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  color: rgba(0, 0, 0, 0.5);\n  font-weight: 800;\n}\n\n.session-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.security-log .activity-list-item {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 8px 10px;\n}\n\n.password-rules {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rule-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f7f8ff;\n}\n\n.privacy-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.privacy-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.settings-toast {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1200;\n  max-width: 420px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-weight: 700;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 12px 28px rgba(3, 9, 30, 0.35);\n  backdrop-filter: blur(8px);\n}\n\n.settings-toast.info {\n  color: #eaf0ff;\n  background: rgba(49, 82, 174, 0.92);\n}\n\n.settings-toast.success {\n  color: #dfffea;\n  background: rgba(23, 121, 70, 0.92);\n}\n\n.settings-toast.error {\n  color: #ffe8ea;\n  background: rgba(150, 33, 54, 0.92);\n}\n\n.settings-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  background: rgba(5, 8, 20, 0.58);\n  display: grid;\n  place-items: center;\n  padding: 20px;\n}\n\n.settings-dialog {\n  width: min(520px, 100%);\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: linear-gradient(155deg, rgba(25, 33, 72, 0.96), rgba(16, 22, 50, 0.96));\n  box-shadow: 0 24px 60px rgba(4, 8, 25, 0.42);\n}\n\n.settings-dialog.danger {\n  border-color: rgba(231, 82, 119, 0.4);\n}\n\n.settings-dialog.warning {\n  border-color: rgba(231, 174, 82, 0.4);\n}\n\n.settings-dialog-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #f6f8ff;\n}\n\n.settings-dialog-message {\n  color: rgba(232, 237, 255, 0.85);\n  font-size: 14px;\n}\n\n.settings-dialog-password-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.settings-dialog-input {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.18);\n  color: #f7f8ff;\n}\n\n.settings-dialog-input::placeholder {\n  color: rgba(232, 237, 255, 0.56);\n}\n\n.settings-dialog-error {\n  color: #ff8ea3;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.settings-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n@media (max-width: 1100px) {\n  .settings-hero {\n    flex-direction: column;\n  }\n\n  .settings-hero-meta {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .settings-row {\n    grid-template-columns: 1fr;\n  }\n\n  .account-field-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .subscription-current {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .settings-tabs {\n    gap: 8px;\n  }\n\n  .settings-tab {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .settings-hero-meta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .account-field-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .account-field-grid .settings-field--wide {\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
